import React, { useState, useEffect, useRef } from "react";
import ReactEcharts from "echarts-for-react";
import axios from "axios";
import API from "@/api";
import GbiArrow from "../../../../../assets/images/gbiArrow.svg";
import { Modal } from "antd";
import DetailTable from "../detailTable";

function LineData(props) {
  const {
    data: initialData = {},
    qsycData,
    drillable,
    drillActions,
    question_id,
    changSpining,
  } = props;
  console.log(qsycData, "趋势预测的数据");
  const [historyStack, setHistoryStack] = useState([
    {
      title: drillable === "true" || drillable === true ? "" : "",
      rawData: initialData,
    },
  ]);

  useEffect(() => {
    setHistoryStack([
      {
        title: drillable === "true" || drillable === true ? "" : "",
        rawData: initialData,
      },
    ]);
  }, [initialData]);
  const currentStackItem = historyStack[historyStack.length - 1];
  const currentData = currentStackItem.rawData;

  const lastClickedDimRef = useRef(null);

  const [newDrillable, setNewDrillable] = useState(drillable);
  const { metric_fields, data: dData, dim_field } = currentData;
  const [dimField, setDimField] = useState(currentData?.dim_field?.field);
  const [newActionId, setNewActionId] = useState(
    drillActions?.[0]?.action_id || "",
  );
  const [detailable, setDetailable] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const dimFieldRef = useRef(dimField);
  const drillableRef = useRef(newDrillable);
  const actionIdRef = useRef(newActionId);
  const xAxisData = (dData || []).map((item) => item[0]);
  const seriesConfig = (metric_fields || [])
    .map((metric, index) => {
      if (qsycData?.forecast_points && qsycData?.forecast_points.length) {
        // --- 提取老数据 ---
        const oldData = dData.map((row) => row[index + 1]);
        const oldLength = oldData.length;

        // --- 提取新数据（追加的数据） ---
        const newData = (qsycData?.forecast_points || []).map(
          (item) => item.value,
        );
        const newLength = newData.length;

        // --- 构造 X 轴 ---
        // 注意：这里假设 dData 的 X 轴在 row[0]，根据实际情况调整
        const oldXAxis = dData.map((row) => row[0]);
        const newXAxis = qsycData?.forecast_points.map((item) => item.label);
        const fullXAxis = [...oldXAxis, ...newXAxis];

        // --- 构造实线数据 ---
        // 逻辑：保留老数据 + 后面补 null (长度与新数据一致)
        const solidData = [...oldData, ...new Array(newLength).fill(null)];

        // --- 构造虚线数据 ---
        // 逻辑：
        // 1. 前面补 null (长度 = 老数据长度 - 1)
        // 2. 取出老数据的最后一个值，作为连接点
        // 3. 拼接新数据
        const connectValue = oldData[oldLength - 1];
        const dashedData = [
          ...new Array(oldLength - 1).fill(null),
          connectValue,
          ...newData,
        ];

        // --- 返回 Series ---
        return [
          {
            // --- 底层：实线 (仅显示老数据部分) ---
            name: metric.name,
            type: "line",
            data: solidData,
            smooth: true,
            lineStyle: {
              color: metric.color || "#2094ff",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
            symbolSize: 8,
            symbolColor: "#ff4500",
            symbolStrokeColor: "#fff",
            symbolStrokeWidth: 2,
            emphasis: { symbolSize: 12 },
          },
          {
            // --- 顶层：虚线 (显示新数据部分) ---
            name: metric.name,
            type: "line",
            data: dashedData,
            smooth: true,
            lineStyle: {
              color: metric.color || "#2094ff",
              width: 2,
              type: "dashed", // 虚线
            },
            symbol: "none", // 虚线部分不显示点，保持清爽
            showSymbol: false,
          },
        ];
      }

      return {
        name: metric.name, // 系列名称，如 "男生人数"
        type: "line", // 图表类型，这里默认为柱状图
        // 数据映射：
        // 原始数据是 ['2025', 1362, 974]
        // 男生对应 index 1 (即 index + 1)，女生对应 index 2
        data: dData.map((row) =>
          typeof row[index + 1] === "number"
            ? row[index + 1]
            : typeof row[index + 1] === "string"
            ? row[index + 1].replace("%", "") * 1
            : 0,
        ),
        type: "line",
        smooth: true,
        lineStyle: {
          color: "#2094ff", // 折线颜色，比如红色
          width: 2, // 折线宽度，可选
        },
        symbol: "circle", // 折点形状（circle=圆形，还可设为rect=矩形、triangle=三角形等）
        symbolSize: 8, // 折点大小（数值越大，折点越大）
        symbolColor: "#ff4500", // 折点填充色（橙色，醒目）
        symbolStrokeColor: "#fff", // 折点边框色（白色）
        symbolStrokeWidth: 2, // 折点边框宽度（增强对比）
        // 可选：鼠标悬浮时折点放大，提升交互体验
        emphasis: {
          symbolSize: 12, // 悬浮时折点放大到12px
        },
      };
    })
    .flat();

  useEffect(() => {
    dimFieldRef.current = dimField;
  }, [dimField]);

  useEffect(() => {
    drillableRef.current = newDrillable;
  }, [newDrillable]);

  useEffect(() => {
    actionIdRef.current = newActionId;
  }, [newActionId]);

  const getOptions = () => {
    let obj = {
      tooltip: {
        trigger: "item", // 触发类型：坐标轴触发（鼠标移到折点上会自动高亮并显示）
        axisPointer: {
          // 坐标轴指示器配置
          type: "cross", // 指示器类型：十字准星（也可以设为 'line' 只显示垂直线）
          label: {
            backgroundColor: "#6a7985",
          },
        },
        // 可选：自定义显示内容格式
        // formatter: "{b} <br/>{a}: {c}",
        // {b}: 年份, {a}: 系列名, {c}: 数值
        formatter: function (params) {
          // params 是一个数组，包含当前 axis 上所有 series 的数据
          let result =
            params.name +
            "<br/>" +
            `${params.seriesName}: ${
              params.value.toLocaleString() + metric_fields?.[0]?.unit || ""
            }<br/>`; // 显示日期或类目
          return result;
        },
      },
      grid: {
        left: 20, // 左边距20px
        right: 20, // 右边距20px
        bottom: xAxisData.length < 15 ? "5%" : 50,
        top: xAxisData.length < 15 ? 60 : 40,
        containLabel: true,
      },
      dataZoom:
        xAxisData.length < 15
          ? undefined
          : [
              {
                type: "inside",
                startValue: 0,
                endValue: 14,
              },
              {
                type: "slider",
              },
            ],
      xAxis: {
        type: "category",
        data:
          qsycData?.forecast_points && (qsycData?.forecast_points || []).length
            ? [
                ...dData.map((r) => r[0]),
                ...(qsycData?.forecast_points || []).map((i) => i.label),
              ]
            : xAxisData,

        axisLabel: {
          // interval: 0,
          // // 设置宽度
          // width: 50,
          // // 超出部分截断并显示省略号
          // overflow: "truncate",
          // // 可选：设置省略号的内容
          // ellipsis: "...",
          rotate: xAxisData.length < 10 ? 0 : 15, // 稍微倾斜一点
          // 或者使用 formatter 进行截断处理
          formatter: function (value) {
            if (xAxisData.length < 10) {
              return value;
            } else {
              if (value.length > 5) {
                return value.substring(0, 5) + "...";
              }
              return value;
            }
          },
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: `{value}${metric_fields?.[0]?.unit || ""}`,
        },
      },

      series: seriesConfig,
      legend: {
        data: (metric_fields || []).map((m) => m.name), // 自动提取图例名称
        top: 10,
      },
    };
    return obj;
  };

  const handleChartClick = (params) => {
    console.log(params);
    //确保点击的是数据点
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      const clickedDimName = params.name;

      // 3. 核心修复：防重判断
      // 如果当前点击的维度和上一次完全一样，直接 return，拦截重复请求
      if (lastClickedDimRef.current === clickedDimName) {
        return;
      }
      if (newDrillable === true || newDrillable === "true") {
        changSpining(true);
      } else {
        changSpining(false);
      }
      // 更新 ref 为当前点击的维度
      lastClickedDimRef.current = clickedDimName;
      if (newDrillable === true || newDrillable === "true") {
        axios
          .post(API.getFilterAndNextData, {
            question_id,
            dim_field: dimFieldRef.current,
            dim_value: clickedDimName || "",
            // drill_path_id: actionIdRef?.current || "",
          })
          .then((res) => {
            const newData = res?.data?.chart_data || {};
            // 将新层级压入栈中
            setNewDrillable(res?.data?.drillable);
            setDetailable(res?.data?.detailable);
            setHistoryStack((prev) => {
              // 始终保留第一项（全部/根节点）的数据引用
              const firstItem = prev[0] || {
                title: "全部",
                rawData: initialData,
              };

              // 返回：[根节点, ...中间所有层级, 新节点]
              return [
                { title: "全部", rawData: firstItem.rawData },
                ...prev.slice(1),
                { title: clickedDimName, rawData: newData },
              ];
            });
            setDimField(res?.data?.chart_data?.dim_field?.field);
            setNewActionId(res?.data?.drill_actions?.[0]?.action_id || "");
            changSpining(false);
          })
          .catch((err) => {
            console.error("下钻请求失败", err);
          });
      } else {
        console.log("不能下钻啦");
      }
    }
  };

  // 3. 处理面包屑点击（返回）
  const handleBreadcrumbClick = (index) => {
    // 如果点击的是当前层级，不做操作
    if (index === historyStack.length - 1) return;

    // 截取数组，保留到点击的那一层
    if (index === 0) {
      setHistoryStack((prev) => {
        console.log(prev.slice(0, index + 1));
        const item = prev.slice(0, index + 1)?.[0];
        return [{ ...item, title: "" }];
      });
    } else {
      setHistoryStack((prev) => prev.slice(0, index + 1));
    }
    lastClickedDimRef.current = "";
    setNewDrillable(true);
    setDetailable(false);
    setDimField(historyStack[index]?.rawData?.dim_field?.field);
  };

  const handleDetail = (params) => {
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      if (detailable) {
        setDetailOpen(true);
        lastClickedDimRef.current = params?.name;
      }
    }
  };

  return (
    <>
      <ReactEcharts
        key={JSON.stringify(currentData)}
        style={{
          minHeight: "225px",
          maxHeight: "300px",
          width: "100%",
        }}
        notMerge={true} // 推荐开启，确保每次 setOption 替换旧配置而不是合并
        lazyUpdate={true}
        option={getOptions()}
        onEvents={
          newDrillable === "true" || newDrillable === true
            ? {
                click: handleChartClick,
              }
            : {
                click: handleDetail,
              }
        }
      />

      {/* 4. 渲染面包屑导航 */}
      <div
        className="historyStack"
        style={{
          padding: drillable === "true" || drillable === true ? "" : "unset",
        }}
      >
        <div>
          {historyStack.map((item, index) => (
            <span key={index}>
              {/* 如果不是最后一项，或者虽然是最后一项但还有下级（理论上最后一项是当前），都可以点击 */}
              <span
                style={
                  index === historyStack.length - 1
                    ? {}
                    : {
                        cursor: "pointer",
                        color: "#1C69FC",
                      }
                } // 当前层级不加手型样式
                onClick={() => handleBreadcrumbClick(index)}
              >
                {item.title}
              </span>
              {/* 如果不是最后一项，显示分隔符 */}
              {index < historyStack.length - 1 && (
                <span
                  style={{
                    padding: "0 10px ",
                  }}
                >
                  <img
                    style={{
                      width: "8px",
                    }}
                    src={GbiArrow}
                    alt=" "
                  />
                </span>
              )}
            </span>
          ))}
        </div>
        <div
          style={{
            color: "#aaa",
          }}
        >
          {drillable === "true" || drillable === true
            ? "点击维度可下钻"
            : detailable
            ? "点击维度可下钻"
            : undefined}
        </div>
      </div>

      <Modal
        title="明细表"
        destroyOnHidden
        open={detailOpen}
        onCancel={() => {
          setDetailOpen(false);
        }}
        width={800}
        footer={null}
      >
        <DetailTable
          question_id={question_id}
          drillActions={newActionId}
          dimField={dimField}
          dimValue={lastClickedDimRef.current}
        />
      </Modal>
    </>
  );
}

export default LineData;
